import {Component, ElementRef, input, output, viewChild} from '@angular/core';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {FloatLabel} from 'primeng/floatlabel';
import {Textarea} from 'primeng/textarea';

@Component({
  selector: 'elcia-text-area',
  imports: [ReactiveFormsModule, FloatLabel, Textarea],
  templateUrl: './text-area.html',
  styleUrl: './text-area.scss',
})
export class TextArea {
  control = input.required<FormControl<string | null>>();
  label = input<string>();
  rows = input<number>(5);
  placeholder = input<string>('');

  readonly inputEvent = output<Event>();
  readonly keydownEvent = output<KeyboardEvent>();

  private textareaEl = viewChild.required<ElementRef<HTMLTextAreaElement>>('textareaRef');

  get nativeEl(): HTMLTextAreaElement {
    return this.textareaEl().nativeElement;
  }
}
